import classNames from "classnames";
import * as React from "react";
import { Skeleton } from "../../../../core/ui";

function getTabHeaderSkeletons(count: number) {
  const tabHeaders: React.ReactElement<HTMLElement>[] = [];

  for (let idx = 0; idx < count; idx++) {
    tabHeaders.push(
      <div
        className={classNames("coast-media-tab-header skeleton", {
          active: !idx,
        })}
        key={idx}
      >
        <Skeleton pulse={true} type="text" name="thumbnail" size={5} />
      </div>,
    );
  }

  return tabHeaders;
}

export const EpisodesSkeletons = ({ count }: { count: number }) => {
  const episodes: React.ReactElement<HTMLElement>[] = [];

  for (let idx = 0; idx < count; idx++) {
    episodes.push(
      <figure className="component-coast-media-episode skeleton" key={idx}>
        <div className="thumb-container">
          <Skeleton pulse={true} type="image" name="thumbnail" shape="16x9" />
        </div>
        <figcaption>
          <Skeleton pulse={true} type="text" name="thumbnail" size={5} />
        </figcaption>
      </figure>,
    );
  }

  return <>{episodes}</>;
};

export const CoastMediaTabSkeleton = ({ count = 12 }: { count?: number }) => {
  return (
    <div className="component-coast-media-tab active">
      <div className="episodes-container">
        <EpisodesSkeletons count={count} />
      </div>
    </div>
  );
};

export const CoastMediaTabsSkeleton = ({ tabs, perTab }: { tabs: number; perTab?: number }) => {
  return (
    <div className="component-coast-media-tabs">
      <div className="component-coast-media-navigation">
        <div />
        <div className="tab-headers-container">{getTabHeaderSkeletons(tabs)}</div>
      </div>

      <div className="tabs-container">
        <CoastMediaTabSkeleton count={perTab} />
      </div>
    </div>
  );
};
